import { render } from "./Importance.vue?vue&type=template&id=4fa57aa0&scoped=true"
import script from "./Importance.vue?vue&type=script&lang=js"
export * from "./Importance.vue?vue&type=script&lang=js"

import "./Importance.vue?vue&type=style&index=0&id=4fa57aa0&lang=scss&scoped=true"

import exportComponent from "/Users/andreigeana/Documents/Projects/KidsStuff/babies/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fa57aa0"]])

export default __exports__